import { withTabItems } from '../common/RoutableTabContainer';
import BankCashTransactionList from './BankCashTransactionList';

export default withTabItems([
  {
    label: 'Cash Txn',
    url: 'cash-transactions',
    comp: BankCashTransactionList,
  },
], () => 'Bank Activity \u2022 ');
